document.addEventListener('DOMContentLoaded', () => {
  const sections = document.querySelectorAll('.section-wb-polished');

  sections.forEach(section => {
    const track = section.querySelector('.wb-pol__track');
    const cards = section.querySelectorAll('.wb-pol__card');
    const progressBar = section.querySelector('.wb-pol__progress-bar');
    const navContainer = section.querySelector('.wb-pol__nav-top');
    const prevBtn = section.querySelector('.wb-pol__arrow-top--prev');
    const nextBtn = section.querySelector('.wb-pol__arrow-top--next');
    
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('in-view');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.1 });

    cards.forEach(card => observer.observe(card));

    const updateState = () => {
      if (!track) return;
      const maxScroll = track.scrollWidth - track.clientWidth;
      const current = track.scrollLeft;
      
      if (navContainer) {
        if (maxScroll <= 5) {
          navContainer.style.display = 'none';
        } else {
          navContainer.style.display = 'flex';
        }
      }

      if (maxScroll > 0 && progressBar) {
        const progress = (current / maxScroll) * 100;
        progressBar.style.width = `${progress}%`;
      }

      if (prevBtn && nextBtn) {
        prevBtn.disabled = current <= 5;
        nextBtn.disabled = current >= maxScroll - 5;
      }
    };

    if (track) {
      track.addEventListener('scroll', updateState);
      window.addEventListener('resize', updateState);
      setTimeout(updateState, 200);

      if (prevBtn) prevBtn.addEventListener('click', () => {
        track.scrollBy({ left: -track.clientWidth / 2, behavior: 'smooth' });
      });
      if (nextBtn) nextBtn.addEventListener('click', () => {
        track.scrollBy({ left: track.clientWidth / 2, behavior: 'smooth' });
      });
    }

    cards.forEach(card => {
      const galleryItems = card.querySelectorAll('.wb-pol__gallery-item');
      const innerPrev = card.querySelector('.wb-pol__inner-arrow--prev');
      const innerNext = card.querySelector('.wb-pol__inner-arrow--next');
      const cartIcon = card.querySelector('.wb-pol__cart-icon');
      
      if (cartIcon) {
        cartIcon.addEventListener('click', (e) => {
          e.preventDefault();
          e.stopPropagation();
          const hasVariants = cartIcon.dataset.hasVariants === 'true';
          const href = cartIcon.dataset.href;

          if (hasVariants) {
            card.classList.toggle('show-variants');
          } else {
            window.location.href = href;
          }
        });
      }
      
      if (galleryItems.length > 1 && innerPrev && innerNext) {
        let currentIdx = 0;
        const showItem = (idx) => {
          galleryItems.forEach(item => item.classList.remove('is-active'));
          galleryItems[idx].classList.add('is-active');
        };

        innerPrev.addEventListener('click', (e) => {
          e.preventDefault(); e.stopPropagation();
          currentIdx = (currentIdx - 1 + galleryItems.length) % galleryItems.length;
          showItem(currentIdx);
        });

        innerNext.addEventListener('click', (e) => {
          e.preventDefault(); e.stopPropagation();
          currentIdx = (currentIdx + 1) % galleryItems.length;
          showItem(currentIdx);
        });
      }
    });

    const addBtns = section.querySelectorAll('.wb-pol__variant-btn');
    addBtns.forEach(btn => {
      btn.addEventListener('click', async (e) => {
        e.preventDefault();
        e.stopPropagation();
        
        const variantId = btn.dataset.variantId;
        const originalText = btn.innerText;
        btn.innerText = '...';
        
        try {
          const response = await fetch(window.Shopify.routes.root + 'cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
          });
          
          if (response.ok) {
            btn.innerText = 'Ajouté';
            setTimeout(() => { btn.innerText = originalText; }, 2000);
            document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
          } else {
            btn.innerText = 'X';
            setTimeout(() => { btn.innerText = originalText; }, 2000);
          }
        } catch (err) {
          console.error(err);
          btn.innerText = 'X';
        }
      });
    });
  });
});